import { useQuery } from "@tanstack/react-query";
import { IPrepListRes } from "ApiFarm/interface/prep";
import { IProductCatRes } from "ApiFarm/interface/product";
import { fetchPrepList } from "ApiFarm/prep";
import { fetchProductCategory } from "ApiFarm/product";
import { AxiosError } from "axios";
import LayerSettingHead from "ComponentsFarm/LayerSettingHead";
import { PrepStatusWrap } from "ComponentsFarm/styles/common";
import useSelectModal from "HookFarm/useSelectModal";
import { prepStore } from "MobxFarm/store";
import React, { useCallback, useEffect, useState } from "react";

function Prep({ soundEffectPlay }: { soundEffectPlay: (src: string) => void }) {
  const [prepCurNav, setPrepCurNav] = useState(2);

  // 카테고리
  const { data: categoryData } = useQuery<
    { list: IProductCatRes[] },
    AxiosError
  >(["productCategory", "prep"], () =>
    fetchProductCategory({ search_is_prep: 1 })
  );

  //리스트
  const { data: listData, refetch } = useQuery<IPrepListRes, AxiosError>(
    ["prepCategoryList", prepCurNav],
    () => fetchPrepList(prepCurNav)
  );

  console.log("categoryData", categoryData);

  useEffect(() => {
    refetch();
  }, [prepCurNav]);

  const { showLayer, handleSelectLayer } = useSelectModal();

  const handlerShowManagement = useCallback((id: number, prepName: string) => {
    prepStore.product_idx = id;
    prepStore.prep_name = prepName;
    handleSelectLayer("PrepManagement");
  }, []);

  return (
    <PrepStatusWrap className="layer_setting">
      <div className="top">
        <ul className="list_frip_menu">
          {categoryData?.list.map(
            (el) =>
              // 2024.08.12 기준으로 아직 피지만 프랩을 지원하기때문에 레귤러피자 2, 라지피자 10
              (el.product_class_idx === 2 || el.product_class_idx === 10) && (
                <li
                  key={el.product_class_idx}
                  className={prepCurNav === el.product_class_idx ? "on" : ""}
                  onClick={() => {
                    setPrepCurNav(el.product_class_idx);
                    soundEffectPlay("/sound/btn_menu.mp3");
                  }}
                >
                  {el.class_name}
                </li>
              )
          )}
        </ul>
      </div>

      <div className="content">
        <table className="list_prep_items">
          <colgroup>
            <col width="70%" />
            <col width="30%" />
          </colgroup>
          <thead>
            <tr>
              <th>메뉴 선택</th>
              <th>현재 수량</th>
            </tr>
          </thead>
          <tbody>
            {listData?.list.map((el) => (
              <tr
                key={el.product_idx}
                onClick={() => {
                  handlerShowManagement(el.product_idx, el.product_name);
                  soundEffectPlay("/sound/btn_menu.mp3");
                }}
              >
                <td className="title">{el.product_name}</td>
                <td className="quanity">
                  <span className="num">{el.count}</span>
                  <span className="txt">개</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </PrepStatusWrap>
  );
}

export default Prep;
